import { fromEvent as observableFromEvent, Subscription } from 'rxjs';

import { filter } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { NgxPopupComponent } from '../../ngx-popups/ngx-popups/components/popup.component';
import { AutoUnsubscribe } from '../../../../decorators/auto-unsubscribe';

@Component({
    selector: 'app-uploading-popup',
    templateUrl: './uploading-popup.component.html',
    styleUrls: ['./uploading-popup.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class UploadingPopupComponent implements OnInit {
  @Input() popup: NgxPopupComponent;
  @Input() message: string;

  @Output() callback = new EventEmitter<boolean>();
  enterPressObs$ = observableFromEvent(document, 'keydown').pipe(
    filter((keyEv: KeyboardEvent) => keyEv.keyCode === 13 || keyEv.keyCode === 27));
  subsArr$: Subscription[] = [];
  emitted = false;

  ngOnInit() {
  }
}
